import { render, staticRenderFns } from "./VirusPodEpic.vue?vue&type=template&id=6e6c6486&scoped=true&"
import script from "./VirusPodEpic.vue?vue&type=script&lang=ts&"
export * from "./VirusPodEpic.vue?vue&type=script&lang=ts&"
import style0 from "./VirusPodEpic.vue?vue&type=style&index=0&id=6e6c6486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c6486",
  null
  
)

export default component.exports